/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TranscribeLanguageForTeam {
  INHERIT = 'inherit',
  DETECT = 'detect',
  MULTI = 'multi',
  KO = 'ko',
  EN = 'en',
  JA = 'ja',
  ZH = 'zh',
  ES = 'es',
  FR = 'fr',
  DE = 'de',
  RU = 'ru',
  PT = 'pt',
  IT = 'it',
  AR = 'ar',
  HI = 'hi',
  ID = 'id',
  VI = 'vi',
  TH = 'th',
  NL = 'nl',
}
